import {Component, Inject} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {FormsModule} from '@angular/forms';
import {Folder, Mutation, Query} from '../../../types-repository';
import {FILE_FOLDER_LIST, MKDIR} from '../../../queries-repository';

@Component({
  selector: 'app-folder-picker-dialog',
  templateUrl: './folder-picker-dialog.component.html',
  styleUrls: ['./folder-picker-dialog.component.scss'],
  imports: [FormsModule]
})
export class FolderPickerDialogComponent {
  folder: Folder | null = null;
  loading = true;
  errorMessage: string | null = null;
  new_folder_name = '';
  creating = false;

  constructor(
    public dialogRef: DialogRef<string>,
    @Inject(DIALOG_DATA) public data: { start: string },
    private apollo: Apollo,
  ) {
    this.load(data.start);
  }

  private load(id: string) {
    this.loading = true;
    this.errorMessage = null;
    this.apollo.query<Query>({
      query: FILE_FOLDER_LIST,
      fetchPolicy: 'network-only',
      variables: {id}
    }).subscribe({
      next: res => {
        this.loading = false;
        this.folder = res.data.folder;
      },
      error: err => {
        this.loading = false;
        this.errorMessage = `Could not open ${id}: ${err.message}`;
      }
    });
  }

  open(sub: Folder) {
    this.load(sub.id);
  }

  up() {
    const parents = this.folder?.parents ?? [];
    if (parents.length) {
      this.load(parents[parents.length - 1].id);
    }
  }

  createFolder() {
    const name = this.new_folder_name?.trim();
    if (!name || !this.folder) {
      return;
    }
    if (name.includes('/')) {
      this.errorMessage = 'Folder name must not contain "/"';
      return;
    }
    this.creating = true;
    const newId = this.folder.id + name + '/';
    this.apollo.mutate<Mutation>({
      mutation: MKDIR,
      variables: {folder_id: newId}
    }).subscribe({
      next: () => {
        this.creating = false;
        this.new_folder_name = '';
        this.load(newId);
      },
      error: err => {
        this.creating = false;
        this.errorMessage = `Failed to create folder: ${err.message}`;
      }
    });
  }

  selectCurrent() {
    if (this.folder) {
      this.dialogRef.close(this.folder.id);
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
